import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { GitSyncBanner } from '../components/GitSyncBanner';

const pageTitles: Record<string, string> = {
  '/': 'Dashboard',
  '/fluxo-de-caixa': 'Fluxo de Caixa',
  '/dre': 'DRE',
  '/projecao': 'Projeção Mensal',
  '/fluxo-projetado': 'Fluxo de Caixa Projetado (13 semanas)',
  '/extrato': 'Extrato',
  '/contas-pagar': 'Passivo',
  '/contas-receber': 'Contas a Receber',
  '/relatorios': 'Relatórios',
  '/users': 'Usuários',
};

export const DashboardLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const title = pageTitles[location.pathname] || 'Ledger Empresa';

  return (
    <div className="flex h-screen bg-slate-100 overflow-hidden">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <TopBar
          title={title}
          onMenuClick={() => setSidebarOpen(true)}
        />

        <GitSyncBanner />

        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
